import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class StickyBuyButtons extends Component {
  get buyButton () {
    return this.querySelector('.js-buy-button')
  }

  connectedCallback () {
    this.variantPickerVisible = false
    this.buttonsVisible = false

    const observer = new IntersectionObserver(this.observerCallback, {
      rootMargin: '0px'
    });

    document.querySelectorAll('.variant-picker-main, .product-form-buttons').forEach((i) => {
      if (i) {
        observer.observe(i);
      }
    });

    this.setupEventListeners()
  }

  observerCallback(entries) {
    entries.forEach(entry => {
      if (entry.target.classList.contains('variant-picker-main')) this.variantPickerVisible = entry.isIntersecting
      if (entry.target.classList.contains('product-form-buttons')) this.buttonsVisible = entry.isIntersecting

      document.querySelector('.js-sticky-atc-container').classList[(this.variantPickerVisible || this.buttonsVisible) ? 'remove' : 'add']('is-visible')
    });
  }

  setupEventListeners() {
    document.addEventListener(ThemeEvents.variantUpdate, this.onMainVariantChange.bind(this))
    this.addEventListener('change', this.handleChange.bind(this))

    this.buyButton?.addEventListener('click', this.onButtonClick.bind(this))
  }

  handleChange(e) {
    const { optionValueId } = e.target.dataset
    const mainVariantPicker = document.querySelector(`variant-picker[data-section-id="${this.dataset.sectionId}"]`)
    const option = mainVariantPicker?.querySelector(`[data-option-value-id="${optionValueId}"]`)

    e.target.closest('details').removeAttribute('open')

    option.checked = true
    option.dispatchEvent(new CustomEvent('change', {
      bubbles: true
    }))
  }

  onMainVariantChange (e) {
    const currentVariant = e.detail.resource

    for (const optionEl of this.querySelectorAll('.js-variant-option')) {
      const optionIndex = parseInt(optionEl.dataset.optionIndex)
      const selectedValue = currentVariant.options[optionIndex - 1]
      const handle = optionEl?.dataset.optionHandle

      if (handle === 'color') {

      } else {
        optionEl.querySelector('.js-swatch-current').innerHTML = selectedValue
      }

      optionEl.querySelectorAll('input[type="radio"]').forEach(input => {
        input.checked = input.value === selectedValue
      })
    }

    this.buyButton.disabled = !currentVariant.available
    this.buyButton.innerHTML = currentVariant.available ? this.buyButton.dataset.availableText : this.buyButton.dataset.soldoutText
  }

  onButtonClick(e) {
    this.buyButton.innerHTML = this.buyButton.dataset.addedText

    setTimeout(() => {
      this.buyButton.innerHTML = this.buyButton.dataset.availableText
    }, 1500)
  }
}

if (!customElements.get('sticky-buy-buttons')) {
  customElements.define('sticky-buy-buttons', StickyBuyButtons);
}
